import { MOIS, MOIS_COURT } from '../engine/constants';

// Returns 12 month labels rotated so index 0 = the scenario's start_month.
// startMonth is 0-based (0=Jan, 11=Dec). Out-of-range or missing → defaults to 0.
function rotate(labels, startMonth) {
  const s = Number.isInteger(startMonth) && startMonth >= 0 && startMonth <= 11 ? startMonth : 0;
  return [...Array(12)].map((_, i) => labels[(s + i) % 12]);
}

export function shortMonthLabels(startMonth = 0) {
  return rotate(MOIS, startMonth);
}

export function longMonthLabels(startMonth = 0) {
  return rotate(MOIS_COURT, startMonth);
}
